import { Outlet } from '@remix-run/react';
import { BlankLayout } from './layout';

export default function Route() {
  return (
    <BlankLayout>
      <Outlet />
    </BlankLayout>
  );
}
